import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule} from '@ngx-translate/core';
import {NotificationManager} from '../../common/providers/notification';
import {AppComponent} from './app.component';
import {ROUTER, ROUTER_COMPONENTS} from './app.router';
import {ERROR_PROVIDERS} from './core/error';
import {BOHttpModule, DashboardHttpModule} from './core/http';
import {SESSION_SECURITY_PROVIDERS} from './core/security';
import {TRANSLATE_LOADER_PROVIDER, TranslateManager} from './core/translate';
import {MenuIcon} from './modules/space/menu';
import {MenuResizer} from './modules/space/menu/resizer/menu.resizer.component';
import {SharedModule} from './shared';
import {CapitalizePipe} from "./shared/pipes/capitalize.pipe";
import {CustomerProfilesSharedModule} from './modules/customers/shared';

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {RolesGuard} from "./core/security/roles.guard";


@NgModule({
    imports: [
        BrowserModule,
        TranslateModule.forRoot(TRANSLATE_LOADER_PROVIDER),
        DashboardHttpModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        SharedModule.forRoot(),
        ROUTER,
        BOHttpModule,
        CustomerProfilesSharedModule,

        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatChipsModule,
        MatIconModule,
        MatAutocompleteModule
    ],
    providers: [
        NotificationManager,
        TranslateManager,
        ...ERROR_PROVIDERS,
        ...SESSION_SECURITY_PROVIDERS,
        RolesGuard,
        ...RolesGuard.guards,
        CapitalizePipe
    ],
    declarations: [
        ...ROUTER_COMPONENTS,
        AppComponent,
        MenuResizer,
        MenuIcon
    ],

    bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/app.module.ts